import React from "react";
import { FileText, BadgeDollarSign, KeyRound } from "lucide-react";

const steps = [
  {
    n: "01",
    icon: FileText,
    title: "Tell us about your house",
    body: "Fill out our 60-second form or give us a call. No repairs, no staging, no showings — ever.",
  },
  {
    n: "02",
    icon: BadgeDollarSign,
    title: "Get a fair cash offer",
    body: "Within 24 hours we'll present a no-obligation cash offer based on the local market — not an algorithm.",
  },
  {
    n: "03",
    icon: KeyRound,
    title: "Close on your schedule",
    body: "Pick your closing date — as fast as 7 days. We pay standard closing costs. Walk away with cash in hand.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how"
      data-testid="how-it-works"
      className="border-b border-[var(--c4p-line)] bg-[var(--c4p-ivory)] py-20 lg:py-28"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="flex items-end justify-between gap-8">
          <div className="max-w-2xl">
            <span className="eyebrow">How it works</span>
            <h2 className="font-display mt-4 text-[40px] leading-[1.02] sm:text-[52px] lg:text-[60px]">
              Three steps from inquiry to{" "}
              <span className="font-display-italic text-[var(--c4p-orange)]">cash in hand.</span>
            </h2>
          </div>
          <p className="hidden max-w-sm font-sans-ui text-[15px] leading-relaxed text-[var(--c4p-muted)] lg:block">
            No banks. No realtors. No surprises. Just a straightforward process
            built for sellers who need certainty and speed.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 gap-0 md:grid-cols-3 md:divide-x md:divide-[var(--c4p-line)]">
          {steps.map((s) => (
            <article
              key={s.n}
              data-testid={`step-${s.n}`}
              className="relative px-0 py-8 md:px-8"
            >
              <div className="flex items-center justify-between">
                <span className="font-display text-[56px] text-[var(--c4p-orange)]/30">
                  {s.n}
                </span>
                <span className="grid h-12 w-12 place-items-center rounded-full bg-[var(--c4p-forest)] text-white">
                  <s.icon size={20} />
                </span>
              </div>
              <h3 className="font-display mt-5 text-[26px] leading-tight text-[var(--c4p-forest)]">
                {s.title}
              </h3>
              <p className="mt-3 font-sans-ui text-[14.5px] leading-relaxed text-[var(--c4p-muted)]">
                {s.body}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
